/**
 * Client Feedback (/client-feedbacks)
 * The client-facing review workspace — pick a conversation, walk its thread, and
 * leave per-response feedback. Shares the workspace with the Sentinel Responses
 * page. Listed in the sidebar for anyone granted the client-feedback subject.
 */

import { SentinelReviewWorkspace } from "@/modules/sentinel/sentinel-review-workspace";

export default function ClientFeedbacks() {
  return <SentinelReviewWorkspace listTitle="Client Feedback" readOnly />;
}
